export default {
  http_errors: {
    400: 'Something went wrong... please try again in a moment!',
    401: 'No permissions!',
    403: 'Something went wrong... please try again in a moment!',
    404: 'Something went wrong... please try again in a moment!',
    406: 'Incorrect payment details or validity has expired.',
    429: 'Too many requests. Please try again in a moment',
    500: 'A temporary problem with a redirect to a payment. Choose a different payment method or try again in a moment.',
    503: 'Server error. Please try again.',
    504: 'Waiting time exceeded, please try again.',
  },
  header: {
    language: 'Language',
  },
  buttons: {
    cancel_payment: 'Cancel payment',
    continue_payments: 'Finish the payment',
    back_to_store: 'Back to store\' website ',
    tooltip: 'Click here to complete the payment',
    select: 'Select',
  },
  main_site_view: {
    sub_title: 'Agregator płatności On-line',
    main_description: 'Agregator pozwala skorzystać z jednego z wybranych sposobów płatności, płacąc za wybraną usługę, produkt. Klienci mogą wybrać najbardziej wygodna opcję płatności dla siebie, korzystając z jednego ze sprawdzonych i znanych rozwiązań. ',
    gateways_available: 'Obsługiwane sposoby płatności:',
    gateways: {
      payu: 'Operator płatności internetowych działający jako system, który daje możliwość dokonywania oraz otrzymywania wpłat przez Internet.',
      paypal: 'W PayPal klienci mogą płacić przy użyciu karty kredytowej bądź salda konta PayPal, które można zasilać przelewami z konta bankowego.',
      przelewy24: 'Serwis Przelewy24 udostępnia automatyczne płatności przelewami on-line z 286 banków w Polsce oraz kartami płatniczymi.',
    },
    gateways_descriptions: '',
    more_info: 'Więcej informacji:',
    regulations: 'Regulamin Serwisu Telestrada Payments',
  },
  payment_actions_screen_schema: {
    gateways_list: {
      header_title: 'Choose payment method',
      header_description: 'Choose a payment method that\'s convenient for you and then click "Finish the payment" button',
    },
    credit_card: {
      header_title: 'Pay with Credit Card',
      header_description: 'Give the card details and then click "Finish the payment" button',
    },
    gateways: {
      PayU: {
        description: `An online payment operator acting as a system that gives the possibility to make and receive payments via the Internet between people who have an e-mail account.
        PayU gives you the option of paying by credit card or bank transfer.`,
        name: 'PayU',
      },
      PayPal: {
        description: `In PayPal, customers can pay using a credit card or PayPal account balance,
        which can be credited with transfers from a bank account or other PayPal account.`,
        name: 'PayPal',
      },
      Przelewy24: {
        description: `Przelewy24 provides automatic payments via online transfers from 286 banks in Poland and payment cards: Visa Classic, Visa Electron, EuroCard / MasterCard,
        Diners Club, PBK, JCB.`,
        name: 'Przelewy24',
      },
      CardPayments: {
        description: 'The payment on the internet takes place in the same card as in the ordinary store. We service debit and credit cards, domestic and foreign. Card payments are handled by PayU',
        name: 'Card Payment',
      },
    },
    credit_card_form: {
      back: 'Back',
      form: {
        card_number: 'Card number',
        cvv: 'CVV2/CVC',
        exp_year: 'Year',
        exp_month: 'Month',
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email address',
      },
      placeholders: {
        card_number: 'Enter the card number',
        cvv: 'Enter the CVV2 / CVC2 number',
        first_name: 'First name',
        last_name: 'Last name',
        email: 'Email address',
      },
      errors: {
        required: 'The field is required',
        card_number: 'Invalid card number',
        cvv: 'Incorrect CVV / CVC2 value',
        exp_year: 'Wrong value',
        exp_month: 'Wrong value',
        name: 'Wrong value',
        email: 'Invalid email address',
      },
      extra: {
        credit_card: 'Card type: ',
      },
    },
    no_gateways: 'There are no possible payment methods',
  },
  payment_summary: {
    header_title: 'Payment summary',
    header_description: 'Below is a list of products and a summary of payments',
    payment: {
      title: 'Payment Title',
      product_name: 'Product name',
      quantity: 'Quantity',
      price: 'Price',
      summary_quantitiy: 'Amount of products',
      summary_amount: 'Total',
    },
  },
  after_payment: {
    success: {
      code: 'OK',
      title: 'The payment has been transferred for execution',
      description: 'Thank you. Your payment has just been transferred for execution. In a moment you will be redirected to the store\'s website.',
    },
    error: {
      code: 'ERROR',
      title: 'Ups... something went wrong',
      description: 'Your payment has been canceled. In a moment you will be redirected to the store\'s website.',
    },
  },
  wrong_or_expired_token_page: {
    code: 'ERROR',
    title: 'Missing or incorrect order number',
    description: `An incorrect Order Number was provided or its validity has expired.
      <div class="error-page">
        <small class="error-page__more-info">More details: </small>
        <a href="http://www.telestrada.pl/upload/upload/Regulamin_Telestrada_Payments_24.10.2018.pdf" class="error-page__regulations">
          <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Regulamin Serwisu Telestrada Payments
        </a>
      </div>    
    `,
  },
};



// WEBPACK FOOTER //
// ./src/lang/EN.js